import { useState } from 'react';
import './EmotionCaptures.css';
import { useMsal } from "@azure/msal-react";
import axios from 'axios';

const EmotionCaptures = () => {
    const [comment, setComment] = useState('');
    const [message, setMessage] = useState('');

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const handleSubmit = (e) => {
        e.preventDefault();
        try {
            axios.post(
                process.env.REACT_APP_IPS_FEEDBACK,
                {
                    user: activeAccount.name,
                    comment: comment
                },
                {
                    headers: {
                        'Authorization': localStorage.getItem("token"),
                        'Content-Type': 'application/json'
                    }
                }
            )
                .then(res => {
                    setMessage(res.data.message)
                })
                .catch(err => setMessage(err.data.message))
        }
        catch (error) {
            console.log(error);
        }
    }
    return (
        <div className="emotion_captures">
            <div className='banner'>
                <img src="images/emotion_captures/NewBanner_img.png" alt="Emotion Captures Banner" />
            </div>
            <div className='main_content'>
                <div className='feedback_box'>
                    <form onSubmit={handleSubmit}>
                        <label htmlFor="">Tell us how we can improve</label>
                        <textarea onChange={(e) => { setMessage(''); setComment(e.target.value) }}></textarea>
                        {message && <span>{message}</span>}
                        <input type="submit" />
                    </form>
                </div>
            </div>
        </div>
    )
}

export default EmotionCaptures;